import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { TotalWeightWidget } from "@redotech/redo-merchant-app-common/components/weight-widget/total-weight-widget";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { SetWeightActionStep } from "@redotech/redo-model/advanced-flow/oms/actions";
import {
  Weight,
  WeightFormat,
  WeightUnit,
} from "@redotech/redo-model/outbound-labels/util";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { PartialWithRequiredType } from ".";

export const WeightInput = memo(function WeightInput({
  step,
  setStep,
}: {
  step: PartialWithRequiredType<SetWeightActionStep>;
  setStep: (step: PartialWithRequiredType<SetWeightActionStep>) => void;
}) {
  const team = useRequiredContext(TeamContext);
  const onWeightChange = useHandler((weight: Weight) => {
    setStep({ ...step, weight });
  });

  // Convert step.weight to a Weight object
  const currentWeight =
    step.weight && step.weight.unit && step.weight.value
      ? { unit: step.weight.unit as WeightUnit, value: step.weight.value }
      : { unit: WeightUnit.OUNCE, value: 0 };

  return (
    <Flex align="stretch" dir="column" flex={1}>
      <TotalWeightWidget
        disabled={false}
        onWeightChange={onWeightChange}
        weight={currentWeight}
        weightFormat={
          team?.settings?.outboundLabels?.weightFormat ?? WeightFormat.IMPERIAL
        }
      />
    </Flex>
  );
});
